import { render, staticRenderFns } from "./movingGoodsBox.vue?vue&type=template&id=e4b4a296&scoped=true&"
import script from "./movingGoodsBox.vue?vue&type=script&lang=js&"
export * from "./movingGoodsBox.vue?vue&type=script&lang=js&"
import style0 from "./movingGoodsBox.vue?vue&type=style&index=0&id=e4b4a296&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b4a296",
  null
  
)

export default component.exports